import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import app from "./modules/appParams";

Vue.use(Vuex);

// import crumb from './modules/crumb'
const store = new Vuex.Store({
  state: {
    crumbList: [],
    menuActiveName: "Application",
    // 全局AWS配置
    AWS_CONFIG: {},
    publicKey: "",
    API_CONFIG: {},
  },
  mutations: {
    updateCrumbList(state, { crumbList, name }) {
      // console.log(crumbList, "store");
      state.crumbList = crumbList;
      state.menuActiveName = name;
    },
    updateAWSConfig(state, config) {
      state.AWS_CONFIG = JSON.parse(JSON.stringify(config));
    },
    updatePublicKey(state, config) {
      state.publicKey = config;
    },
    updatePaths(state, paths) {
      state.AWS_CONFIG.paths = paths;
    },
    updateAwsConfigItem(state, config) {
      const { key } = config;
      const { subKey } = config;
      const { val } = config;
      const { AWS_CONFIG } = state;

      if (AWS_CONFIG && key) {
        if (subKey && AWS_CONFIG[key] !== undefined) {
          AWS_CONFIG[key][subKey] = JSON.parse(JSON.stringify(val));
        } else {
          AWS_CONFIG[key] = val;
        }
      }
    },
    updateApiConfig(state, config) {
      state.API_CONFIG = JSON.parse(JSON.stringify(config));
    },
  },
  getters: {
    getAWSConfig(state) {
      return state.AWS_CONFIG;
    },
    getAWSS3CONFIG(state) {
      return state.AWS_CONFIG && state.AWS_CONFIG.S3CONFIG;
    },
    getAwsConfigItem(state) {
      return (obj) => {
        const { key } = obj;
        const { subKey } = obj;
        const { AWS_CONFIG } = state;
        if (key) {
          if (subKey && AWS_CONFIG[key]) {
            return AWS_CONFIG[key][subKey];
          }
          return AWS_CONFIG[key];
        }
        return "";
      };
    },
  },
  actions: {
    updateAWSConfig(context, config) {
      context.commit("updateAWSConfig", config);
    },
    updateAwsConfigItem(context, config) {
      context.commit("updateAwsConfigItem", config);
    },
    updateApiConfig(context, config) {
      context.commit("updateApiConfig", config);
    },
  },
  modules: { app },
  plugins: [createPersistedState()],
});

export default store;
